<template>
<div>
    <el-dialog :title="!dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="70%" :visible.sync="viewData.visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form" size="small">
            <el-tabs>
                <el-tab-pane :key="1" label="基础信息" class="tab_style">
                    <div class="des_box">
                        <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                            <el-descriptions-item label="合同:" :label-style="getStyle()" :content-style="getStyle2()">
                                <!-- {{ dataForm.contractCode }}&nbsp;{{ dataForm.contractName }}&nbsp;&nbsp; -->
                                {{ dataForm.contractName }}
                                <el-button v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" size="small" @click="selectContract()">选择</el-button>
                            </el-descriptions-item>
                            <el-descriptions-item label="甲方签订日:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="partyaSignDate" style="margin-bottom: 0;">
                                    <el-date-picker v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.partyaSignDate" style="width:200px" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                                    </el-date-picker>
                                    <span v-else>{{dateFormatValue(dataForm.partyaSignDate)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="甲方:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="purchasePartya" style="margin-bottom: 0;">
                                    <!-- <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.purchasePartya" placeholder="甲方"></el-input> -->
                                    <el-select v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.purchasePartya" filterable placeholder="请选择">
                                        <el-option v-for="item in purchasePartyAList" :key="item.purchaseOrgCode" :label="item.purchaseOrgName" :value="item.purchaseOrgCode">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{dataForm.purchasePartya}}</span>
                                </el-form-item>
                                <!-- {{dataForm.purchasePartya}}  -->
                            </el-descriptions-item>
                            <el-descriptions-item label="甲方代表:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="partyaRepresentive" style="margin-bottom: 0;">
                                    <!-- <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.partyaRepresentive" placeholder="甲方代表"></el-input> -->
                                    {{dataForm.partyaRepresentive}}&nbsp;&nbsp;<el-button v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" size="small" @click="selectPM()">选择</el-button>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="乙方:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="supplierPartyb" style="margin-bottom: 0;">
                                    <!-- <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.supplierPartyb" placeholder="乙方"></el-input> -->
                                    <span>{{dataForm.supplierPartyb}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="乙方代表:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="partybRepresentive" style="margin-bottom: 0;">
                                    <!-- <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.partybRepresentive" placeholder="乙方代表"></el-input> -->
                                    <span>{{dataForm.partybRepresentive}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="乙方开户行编号:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="supplierPartybBankCode" style="margin-bottom: 0;">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.supplierPartybBankCode" placeholder="乙方开户行编号"></el-input>
                                    <span v-else>{{dataForm.supplierPartybBankCode}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="乙方签订日:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="partybSignDate" style="margin-bottom: 0;">
                                    <el-date-picker v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.partybSignDate" style="width:200px" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                                    </el-date-picker>
                                    <span v-else>{{dateFormatValue(dataForm.partybSignDate)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="乙方税号:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="supplierPartybTaxCode" style="margin-bottom: 0;">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.supplierPartybTaxCode" placeholder="乙方税号"></el-input>
                                    <span v-else>{{dataForm.supplierPartybTaxCode}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="乙方户名:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="supplierPartybBankAccount" style="margin-bottom: 0;">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.supplierPartybBankAccount" placeholder="乙方户名"></el-input>
                                    <span v-else>{{dataForm.supplierPartybBankAccount}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="乙方开户行:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="supplierPartybBank" style="margin-bottom: 0;">
                                    <!-- <el-select v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.supplierPartybBank" filterable clearable placeholder="请选择开户行">
                                        <el-option v-for="item in bankList" :key="item.bankCode" :label="item.bankName" :value="item.bankCode">
                                        </el-option>
                                    </el-select> -->
                                    <el-input v-if="viewFlag !== 'view' && dataForm.supplierPartybBank === '提交价格协议' || !dataForm.id" v-model="dataForm.supplierPartybBank" placeholder="开户行"></el-input>
                                    <span v-else>{{dataForm.supplierPartybBank}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="协议类型:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="agreementType" style="margin-bottom: 0;">
                                    <!-- <el-select v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.agreementType" placeholder="请选择">
                                        <el-option v-for="item in AGREEMENT_TYPE" :key="item.value" :label="item.label" :value="item.value" />
                                    </el-select>
                                    <span v-else>{{getAGREEMENT_TYPE_VALUE(dataForm.agreementType)}}</span> -->
                                    <span>{{getAGREEMENT_TYPE_VALUE(dataForm.agreementType)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="协议状态:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="agreementStatus" style="margin-bottom: 0;">
                                    <!-- <el-select v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.agreementStatus" placeholder="请选择">
                                        <el-option v-for="item in AGREEMENT_STATUS" :key="item.value" :label="item.label" :value="item.value" />
                                    </el-select>
                                    <span v-else>{{getAGREEMENT_STATUS_VALUE(dataForm.agreementStatus)}}</span> -->
                                    <span>{{getAGREEMENT_STATUS_VALUE(dataForm.agreementStatus)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="账期:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="payPeriod" style="margin-bottom: 0;">
                                    <el-select v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.payPeriod" clearable placeholder="请选择" @change="getPayPeriodDesc">
                                        <el-option v-for="item in PAY_PERIOD" :key="item.value" :label="item.label" :value="item.value" />
                                    </el-select>
                                    <span v-else>{{getPAY_PERIOD_VALUE(dataForm.payPeriod)}}</span>
                                    <span style="padding-left:5px;">{{payPeriodObj ? payPeriodObj.desc: ''}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="协议编码:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="priceAgreementCode" style="margin-bottom: 0;">
                                    <span>{{dataForm.priceAgreementCode}}</span>
                                    <!-- <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.priceAgreementCode" placeholder="协议编码"></el-input> -->
                                    <!-- <span v-else>{{dataForm.priceAgreementCode}}</span> -->
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="币种:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="currency" style="margin-bottom: 0;">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.currency" placeholder="币种"></el-input>
                                    <span v-else>{{dataForm.currency}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="税率:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="taxRate" style="margin-bottom: 0;">
                                    <!-- <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.taxRate" placeholder="税率"></el-input> -->
                                    <!-- <span v-else>{{dataForm.taxRate}}</span> -->
                                    <el-select v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.taxRate" clearable filterable placeholder="请选择税码" @change="changeRate">
                                        <el-option v-for="item in taxCodeList" :key="item.taxCode" :label="item.taxRate" :value="item.taxCode">
                                        </el-option>
                                    </el-select>
                                    <span v-else>{{getTaxCodeName(dataForm.taxRate)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="供应商编码:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="partybCode" style="margin-bottom: 0;">
                                    <!-- <el-input v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.partybCode" placeholder="供应商编码"></el-input> -->
                                    <span>{{dataForm.partybCode}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="付款方式:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="payWay" style="margin-bottom: 0;">
                                    <el-select v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" clearable v-model="dataForm.payWay" placeholder="请选择">
                                        <el-option v-for="item in PAY_WAY_VALUE" :key="item.value" :label="item.label" :value="item.value" />
                                    </el-select>
                                    <span v-else>{{(getPAY_WAY_VALUE(dataForm.payWay))}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <!-- <el-descriptions-item label="付款日期:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="payDate" style="margin-bottom: 0;">
                                    <el-date-picker v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.payDate" style="width:200px" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                                    </el-date-picker>
                                    <span v-else>{{(dataForm.payDate)}}</span>
                                </el-form-item>
                            </el-descriptions-item> -->
                            <el-descriptions-item label="协议有效期:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="validityOfContract" style="margin-bottom: 0;">
                                    <el-date-picker v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.validityOfContract" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                    </el-date-picker>
                                    <span v-else>{{(dataForm.contractStartDate)}}-{{(dataForm.contractEndDate)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="采购信息记录分类:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="esokz" style="margin-bottom: 0;">
                                    <el-select v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" clearable v-model="dataForm.esokz" placeholder="请选择">
                                        <el-option v-for="item in PURCHASE_MESSAGE_TYPE" :key="item.value" :label="item.label" :value="item.value" />
                                    </el-select>
                                    <span v-else>{{getPURCHASE_MESSAGE_TYPE_VALUE(dataForm.esokz)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="计划交货天数:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item prop="aplfz" style="margin-bottom: 0;">
                                    <ctl-number v-if="viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" v-model="dataForm.aplfz" :min="0" :max="999" label="描述文字"></ctl-number>
                                    <span v-else>{{(dataForm.aplfz)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-tab-pane>
                <el-tab-pane :key="2" label="零件清单" class="tab_style">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <!-- <el-button size="small" v-if="isAuth('sourcing:priceAgreement:newbutton')" type="primary" @click="addOrUpdatePartListHandle()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                                新增零件清单
                            </el-button> -->
                            <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="partCode" header-align="center" align="left" label="零件编号" width="150">
                                </el-table-column>
                                <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
                                </el-table-column>
                                <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量" width="100">
                                </el-table-column>
                                <el-table-column prop="priceWithoutTax" header-align="center" align="right" label="未税单价" width="100">
                                </el-table-column>
                                <el-table-column prop="sharePriceWithoutTax" header-align="center" align="right" label="净价" width="120">
                                </el-table-column>
                                <el-table-column prop="sharePriceWithoutTaxSap" header-align="center" align="right" label="SAP净价" width="120">
                                    <template slot-scope="scope">
                                        {{ scope.row.sharePriceWithoutTaxSap}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="peinh" header-align="center" align="right" label="价格倍数" width="120">
                                    <template slot-scope="scope">
                                        {{ scope.row.peinh }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="oneCarPriceWithoutTax" header-align="center" align="right" label="单台金额（未税）" width="120">
                                </el-table-column>
                                <el-table-column prop="provisionalEstimate" header-align="center" align="center" label="是否暂估" width="100">
                                </el-table-column>
                                <el-table-column prop="unit" header-align="center" align="center" label="订单单位" width="100">
                                     <template slot-scope="scope">
                                        {{ getUnitValue(scope.row.unit)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="conversionMolecule" header-align="center" align="left" label="转换分子" width="100">
                                </el-table-column>
                                <el-table-column prop="conversionDenominator" header-align="center" align="left" label="转换分母" width="100">
                                </el-table-column>
                                <el-table-column prop="kmein" header-align="center" align="left" label="板材结算单位" width="100">
                                    <template slot-scope="scope">
                                        {{ getUnitValue(scope.row.kmein)}}
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="isAuth('sourcing:priceAgreement:newbutton') && viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议'" header-align="center" align="left" width="150" label="操作" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="addOrUpdatePartListHandle(scope.row)" icon="el-icon-edit">
                                            修改
                                        </el-button>
                                        <el-button type="text" size="small" @click="deleteHandlePartList(scope.row.id)" icon="el-icon-delete" class="button-danger">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
                            </el-pagination>
                        </el-col>
                    </el-row>
                    <!--  <el-row v-if="false">
                    <el-col :span="24" >
                    <el-form-item label="路径" prop="path">
                        <el-input v-model="dataForm.path" readonly placeholder="路径"></el-input>
                    </el-form-item>
                    </el-col>
                </el-row>   -->
                </el-tab-pane>
                <el-tab-pane :key="3" label="附件文件" class="tab_style">
                    <!-- TODO:上传下载 产看 需求文档 -->
                    <FilesUpDown ref="filesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
                </el-tab-pane>
            </el-tabs>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <el-button v-if="isAuth('sourcing:priceAgreement:newbutton') && viewFlag !== 'view' && dataForm.agreementStatus === '提交价格协议' || !dataForm.id" size="small" plain type="primary" @click="dataFormSubmit()" :loading="loading">
                保存
            </el-button>
            <div v-if="viewFlag !== 'view'" style="display:inline">
            <span  v-for="(item,index) in dataForm.taskActions" :key="index" style="margin-left: 10px">
                <el-button v-if="item.taskName == '提交价格协议'" size="small" plain type="primary" @click="goToApprove()" :loading="loading">
                    提交审批
                </el-button>
                <span v-if="item.flowRuleType && item.flowRuleType === 'action'">
                    <el-button type="success" size="small" plain @click="execApprove(dataForm.id, item.taskId, item.flowRuleType, item.normalValue,true)" :loading="loading">通过
                    </el-button>
                    <el-button type="danger" size="small" plain @click="unQuote(dataForm.id, item.taskId, item.flowRuleType, item.reverseValue)" :loading="loading">驳回
                    </el-button>
                </span>
            </span>
            </div>
            <!--            agreementStatus -->
        </span>
        <div>
            <!-- 弹窗, 新增 / 修改 零件清单 -->
            <add-or-update-partList v-if="addOrUpdatePartListVisible" ref="addOrUpdatePartList" @refreshPartDataList="getPriceAgreementPartList"></add-or-update-partList>
            <!-- 弹窗, 查询项目管理表-->
            <contract-list ref="addOrUpdateContract"></contract-list>
            <common-user-dialog ref="commonUserDialog"></common-user-dialog>
        </div>
    </el-dialog>

    <el-dialog :title="'提示'" width="30%" :close-on-click-modal="false" :visible.sync="unQuoteReasonFlag">
        <el-row>
            <el-form label-width="0px" :rules="dataRule2" :model="dataForm" ref="dataForm">
                <el-form-item prop="unQuoteReason">
                    <el-input type="textarea" :rows="10" placeholder="请输入驳回原因" maxlength="200" v-model="dataForm.unQuoteReason">
                    </el-input>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row type="flex" justify="end">
            <el-button size="small" @click="unQuoteReasonFlag = false">取 消</el-button>
            <el-button size="small" plain type="primary" @click="UpdateBybohui()">确 定</el-button>
        </el-row>
    </el-dialog>
</div>
</template>

<script>
import {
    getPriceAgreementById,
    editPriceAgreement,
    createPriceAgreement,
    getPriceAgreementPartList,
    removePriceAgreementPartList,
    toApprove,
    execTask
} from '@/controller/priceAgreement'
import {
    USER_TYPE,
    PAY_PERIOD,
    getPAY_PERIOD_VALUE,
    PAY_WAY_VALUE,
    getPAY_WAY_VALUE,
    AGREEMENT_TYPE,
    getAGREEMENT_TYPE_VALUE,
    AGREEMENT_STATUS,
    getAGREEMENT_STATUS_VALUE,
    DIALOG_CLOSED_TYPE,
    PURCHASE_MESSAGE_TYPE,
    getPURCHASE_MESSAGE_TYPE_VALUE,
    getUnitValue
} from '@/utils/const'
import moment from 'moment'
import {
    getBankList,
    getTaxCodeList,
    getPurchaseOrgList
} from '@/controller/systemData'
import CommonUserDialog from "@/views/common/common-user-dialog";
import FilesUpDown from "@/views/common/file-up-down";
import ContractList from "./contract-list";
import AddOrUpdatePartList from "./partList-add-or-update";
import CtlNumber from '@/views/common/ctl-number'
import {
    mapping
} from "@/utils";
import {
    setLoading
} from "@/utils/index";
// require('@/mock/mockPriceAgreement');
export default {
    data() {
        let checkData = (rule, value, callback) => {
            console.log('checkData...')
            if (!value) {
                this.loading = false
                return callback(new Error(rule.message))
            } else if (value.length == 1 && !value[0]) {
                this.loading = false
                callback(new Error(rule.message));
            } else {
                callback();
            };
        }
        return {
            FILE_BIZ_TYPE: 8,
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            purchasePartyAList: [],
            payPeriodObj: {},
            taxCodeList: [],
            bankList: [],
            viewFlag: '',
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            // 订单单位
            getUnitValue:getUnitValue,
            // 账期
            PAY_PERIOD: PAY_PERIOD,
            getPAY_PERIOD_VALUE: getPAY_PERIOD_VALUE,
            //结算方式
            PAY_WAY_VALUE: PAY_WAY_VALUE,
            getPAY_WAY_VALUE: getPAY_WAY_VALUE,
            //协议状态
            AGREEMENT_STATUS: AGREEMENT_STATUS,
            getAGREEMENT_STATUS_VALUE: getAGREEMENT_STATUS_VALUE,
            //协议类型
            AGREEMENT_TYPE: AGREEMENT_TYPE,
            getAGREEMENT_TYPE_VALUE: getAGREEMENT_TYPE_VALUE,
            //采购信息记录分类
            PURCHASE_MESSAGE_TYPE: PURCHASE_MESSAGE_TYPE,
            getPURCHASE_MESSAGE_TYPE_VALUE: getPURCHASE_MESSAGE_TYPE_VALUE,
            dataList: [],
            validityOfContract: '',
            dataForm: {
                contractId: '',
                contractCode: '',
                contractName: '',
                partybCode: '',
                priceAgreementCode: '',
                purchasePartya: '',
                supplierPartyb: '',
                agreementType: '',
                payDate: '',
                payWay: '',
                payPeriod: '',
                agreementMoney: '',
                taxRate: '',
                supplierPartybBankAccount: '',
                supplierPartybBank: '',
                supplierPartybBankCode: '',
                supplierPartybTaxCode: '',
                partyaRepresentive: '',
                partyaSignDate: '',
                partybRepresentive: '',
                partybSignDate: '',
                agreementStatus: '',
                contractStartDate: '',
                contractEndDate: '',
                unQuoteReason: '',
                currency:'',
                esokz: '',
                aplfz: '',
                validityOfContract: '',
                taskActions:[],
            },
            rateValue: 0,
            addOrUpdatePartListVisible: false,
            addOrUpdateContractVisible: false,
            pickerBeginDateBefore: {
                onPick: ({
                    endDate,
                    startDate
                }) => {
                    this.dataForm.contractStartDate = endDate;
                    this.dataForm.contractEndDate = startDate;
                },
            },
            dataRule: {
                purchasePartya: [{
                    message: "甲方不能为空",
                    trigger: "blur",
                    validator: checkData
                }],
                partyaRepresentive: [{
                    message: "甲方代表不能为空",
                    trigger: "blur",
                    validator: checkData
                }],
                taxRate: [{
                    message: "请选择汇率",
                    trigger: "blur",
                    validator: checkData
                }],
                validityOfContract: [{
                    message: "请选择时间段",
                    trigger: 'change',
                    validator: checkData,
                }],
                esokz: [{
                    message: "请选择采购信息记录分类",
                    trigger: "blur",
                    validator: checkData
                }]
            },
            dataRule2: {
                unQuoteReason: [{
                    required: true,
                    message: '驳回原因不能为空',
                    trigger: 'blur'
                }]
            },
            unQuoteReasonFlag: false,
        }
    },
    components: {
        AddOrUpdatePartList,
        ContractList,
        FilesUpDown, //上传附件
        CtlNumber,
        CommonUserDialog
    },
    mounted() {},
    methods: {
        init(contract, id, viewFlag) {
            console.log(id, '============init==============')
            // this.dataForm = data ? data : this.dataForm
            this.getPayPeriodDesc(this.dataForm.payPeriod)
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0;
            this.dataList = [];
            this.viewData.visible = true
            this.loading = false
            this.validityOfContract = ''
            this.$nextTick(() => {
                this.$refs.filesUpDown.init(this.viewFlag);
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getPriceAgreementById({}, this.dataForm.id).then(data => {
                        console.log(data)
                        if (data && data.code === '00' && data.body) {
                            // this.dataForm.priceAgreementCode = data.body.priceAgreementCode;
                            // this.dataForm.purchasePartya = data.body.purchasePartya;
                            // this.dataForm.supplierPartyb = data.body.supplierPartyb;
                            // this.dataForm.agreementType = data.body.agreementType;
                            // this.dataForm.payDate = data.body.payDate;
                            // this.dataForm.payWay = data.body.payWay;
                            // this.dataForm.payPeriod = data.body.payPeriod;
                            // this.dataForm.agreementMoney = data.body.agreementMoney;
                            // this.dataForm.taxRate = data.body.taxRate;
                            // this.dataForm.supplierPartybBankAccount = data.body.supplierPartybBankAccount;
                            // this.dataForm.supplierPartybBank = data.body.supplierPartybBank;
                            // this.dataForm.supplierPartybBankCode = data.body.supplierPartybBankCode;
                            // this.dataForm.supplierPartybTaxCode = data.body.supplierPartybTaxCode;
                            // this.dataForm.partyaRepresentive = data.body.partyaRepresentive;
                            // this.dataForm.partyaSignDate = data.body.partyaSignDate;
                            // this.dataForm.partybRepresentive = data.body.partybRepresentive;
                            // this.dataForm.partybSignDate = data.body.partybSignDate;
                            // this.dataForm.agreementStatus = data.body.agreementStatus;
                            // this.dataForm.partybCode = data.body.partybCode;
                            mapping(data.body, this.dataForm)
                            this.dataForm.contractCode = contract.contractCode
                            this.dataForm.contractName = contract.contractName
                            console.log(data.body);
                            this.validityOfContract = []
                            if (data.body.contractStartDate) {
                                this.validityOfContract.push(data.body.contractStartDate)
                            }
                            if (data.body.contractEndDate) {
                                this.validityOfContract.push(data.body.contractEndDate)
                            }
                            if (!data.body.contractStartDate || !data.body.contractEndDate) {
                                this.dataForm.validityOfContract = ''
                            } else {
                                this.dataForm.validityOfContract = this.validityOfContract
                            }
                            this.getPayPeriodDesc(this.dataForm.payPeriod)
                            this.rateValue = 1 - this.getTaxCodeName(this.dataForm.taxRate) / 100

                        }
                    });
                    this.getPriceAgreementPartList();
                } else {
                    this.dataForm.contractCode = ''
                    this.dataForm.contractName = ''
                    if (!this.payPeriodObj) {
                        this.payPeriodObj = {}
                    }
                    this.payPeriodObj.desc = ''
                }
                // this.getBankList()
                this.getTaxCodeList()
                this.getPurchaseOrgList()
            })
        },
        getBankList() {
            getBankList({
                bankCode: "",
                bankName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.bankList = data.body;
                }
            });
        },
        numLength(val){
            if(val.toString().split(".")[1] !== undefined){
                return Math.pow(10,val.toString().split(".")[1].length-2)
            } else{
                return val
            }
            
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        getPayPeriodDesc: function (value) {
            this.payPeriodObj = this.PAY_PERIOD.find(obj => obj.value === value)
        },
        getPurchaseOrgList() {
            getPurchaseOrgList({
                purchaseOrgCode: "",
                purchaseOrgName: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.purchasePartyAList = data.body;
                }
            });
        },
        getPurchaseOrgName(code) {
            const purchaseOrg = this.purchasePartyAList.find(purchaseOrg => purchaseOrg.purchaseOrgCode === code)
            return purchaseOrg ? purchaseOrg.purchaseOrgName : ''
        },
        selectPM() {
            // this.$nextTick(() => {
            //     this.dataForm.projectManagerName = 'test'
            // })
            //const _this = this
            this.$refs.commonUserDialog.open(USER_TYPE.MANAGER)
            this.$refs.commonUserDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // this.dataForm.projectManagerId = payload.data.defaultPositionId
                    this.dataForm.partyaRepresentive = payload.data.realName
                }
            };
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setLoading()
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    // this.dataForm.priceAgreementCode = '9999'
                    // this.dataForm.agreementStatus = "0"
                    this.validityOfContract = this.dataForm.validityOfContract
                    let params = {
                        'id': this.dataForm.id || undefined,
                        'contractId': this.dataForm.contractId,
                        'priceAgreementCode': this.dataForm.priceAgreementCode,
                        'agreementStatus': this.dataForm.agreementStatus,
                        'purchasePartya': this.dataForm.purchasePartya,
                        'supplierPartyb': this.dataForm.supplierPartyb,
                        'agreementType': this.dataForm.agreementType,
                        'payDate': this.dataForm.payDate,
                        'payWay': this.dataForm.payWay,
                        'payPeriod': this.dataForm.payPeriod,
                        'agreementMoney': this.dataForm.agreementMoney,
                        'taxRate': this.dataForm.taxRate,
                        'supplierPartybBankAccount': this.dataForm.supplierPartybBankAccount,
                        'supplierPartybBank': this.dataForm.supplierPartybBank,
                        'supplierPartybBankCode': this.dataForm.supplierPartybBankCode,
                        'supplierPartybTaxCode': this.dataForm.supplierPartybTaxCode,
                        'partyaRepresentive': this.dataForm.partyaRepresentive,
                        'partyaSignDate': this.dataForm.partyaSignDate,
                        'partybRepresentive': this.dataForm.partybRepresentive,
                        'partybSignDate': this.dataForm.partybSignDate,
                        'partybCode': this.dataForm.partybCode,
                        'contractStartDate': this.validityOfContract && this.validityOfContract.length === 2 ? this.validityOfContract[0] : null,
                        'contractEndDate': this.validityOfContract && this.validityOfContract.length === 2 ? this.validityOfContract[1] : null,
                        'esokz': this.dataForm.esokz,
                        'currency': this.dataForm.currency,
                        'aplfz': this.dataForm.aplfz
                    }
                    if (this.dataForm.id) {
                        editPriceAgreement(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.loading = false
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createPriceAgreement(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.loading = false
                                        this.viewData.visible = false
                                        console.log('refreshDataList')
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        // 选择合同
        selectContract() {
            const _this = this;
            // 条件 甲方编码 1010 乙方编码 A13016 确定合同
            const param = {
                // purchasePartya : this.dataForm.partyaCode,
                partybCode: this.dataForm.partybCode,
            }
            this.$refs.addOrUpdateContract.open(param);
            this.$refs.addOrUpdateContract.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    let filterItem = ['id']
                    if (!_this.dataForm.partybCode) {
                        mapping(payload.data, _this.dataForm, filterItem);
                    }
                    _this.dataForm.partyaSignDate = moment(payload.data.partyaSignDate).format("YYYY-MM-DD HH:mm:ss")
                    _this.dataForm.partybSignDate = moment(payload.data.partybSignDate).format("YYYY-MM-DD HH:mm:ss")
                    _this.dataForm.contractName = payload.data.contractName
                    _this.dataForm.contractCode = payload.data.contractCode
                    _this.dataForm.contractId = payload.data.id
                    _this.dataForm.partybRepresentive = payload.data.partybRepresentive;

                }
            };
        },

        goToApprove() {
            this.loading = true
            setLoading()
            let actions = this.dataForm.taskActions;
            if (actions && actions.length > 0) {
                let action = actions[0];
                this.dataForm.flowTaskId = action.taskId
                this.dataForm.paramKey = action.flowType
                this.dataForm.paramVal = action.val
                this.validityOfContract = this.dataForm.validityOfContract
                toApprove({
                    ...this.dataForm,
                    'contractStartDate': this.validityOfContract && this.validityOfContract.length === 2 ? this.validityOfContract[0] : null,
                    'contractEndDate': this.validityOfContract && this.validityOfContract.length === 2 ? this.validityOfContract[1] : null,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            onClose: () => {
                                this.viewData.visible = false
                                this.loading = false
                                console.log('refreshDataList')
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.error("当前价格协议工作流未启动！不可提交审批")
                this.loading = false
                return
            }

        },

        //驳回原因
        unQuote(id,taskId, flowRuleType, reverseValue) {
            this.dataForm.taskId = taskId
            this.dataForm.flowType = flowRuleType
            this.dataForm.paramVal = reverseValue
            this.dataForm.unQuoteReason = ""
            this.unQuoteReasonFlag = true
            // execApprove(id, taskId, flowType, val,false)
        },
        // 确定驳回
        UpdateBybohui() {
            this.unQuoteReasonFlag = false;
            this.execApprove(this.dataForm.id, this.dataForm.taskId, this.dataForm.flowType, this.dataForm.paramVal, false)
        },
        execApprove(id, taskId, flowType, val, isPass) {
            this.loading = true
            setLoading()
            let text = "通过";
            if (!isPass) {
                text = "驳回";
            }
            this.$confirm(`确定进行${text}操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.validityOfContract = this.dataForm.validityOfContract
                execTask({
                    'id': id,
                    'flowTaskId': taskId,
                    'paramKey': flowType,
                    'paramVal': val,
                    "unQuoteReason": this.dataForm.unQuoteReason,
                    'contractStartDate': this.validityOfContract && this.validityOfContract.length === 2 ? this.validityOfContract[0] : null,
                    'contractEndDate': this.validityOfContract && this.validityOfContract.length === 2 ? this.validityOfContract[1] : null,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            onClose: () => {
                                this.loading = false
                                this.viewData.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
                this.viewData.visible = false;
            });
        },
        // =================== 零件清单表格====================
        getPriceAgreementPartList() {
            getPriceAgreementPartList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                priceAgreementId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total
                } else {
                    this.dataList = [];
                    this.totalPage = 0
                }
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getPriceAgreementPartList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getPriceAgreementPartList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 删除零件清单
        deleteHandlePartList(id) {
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    removePriceAgreementPartList({}, id)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getPriceAgreementPartList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        //  新增 / 修改零件清单
        addOrUpdatePartListHandle(row) {
            this.addOrUpdatePartListVisible = true;
            this.$nextTick(() => {
                const rateValue = this.getTaxCodeName(this.dataForm.taxRate)
                this.$refs.addOrUpdatePartList.init(this.dataForm.id, row.id, rateValue);
            });
        },
        //获取税码信息
        getTaxCodeList() {
            getTaxCodeList({
                taxCode: "",
                taxRate: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.taxCodeList = data.body;
                }
            })
        },
        getBankName(val) {
            const bank = this.bankList.find(bank => bank.bankCode === val)
            return bank ? bank.bankName : ''
        },
        getTaxCodeName(code) {
            const taxCode = this.taxCodeList.find(taxCode => taxCode.taxCode === code)
            return taxCode ? taxCode.taxRate : ''
        },
        changeRate(val) {
            this.rateValue = 1 - this.getTaxCodeName(this.dataForm.taxRate) / 100
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 392px;'
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.mb15 {
    margin-bottom: 15px;
}

.button-danger {
    color: #F56C6C
}

.fr {
    float: right;
}

.tab_style {
    min-height: 60vh;
}
</style>
